import router from "./router";
import store from "./store";
import { getAccessToken, setAccessToken } from "@/utils/auth";
import { Toast } from "vant";
const allAllow = true;
const whiteList = ["114.84.255.98"];

let HOST = process.env.HOST;
let redirectUrl = "";
switch (HOST) {
  case "dev":
    redirectUrl = "http://mobile.weixiao.test.weiguyun.com";
    break;
  case "prod":
    redirectUrl = "https://mobile.weixiao.ct-study.com.cn";
    break;
  case "test":
    redirectUrl = "http://mobile.weixiao.test.weiguyun.com";
    break;
  // https://mobile.weixiao.ct-study.com.cn
  // https://localhost:8080
}

router.beforeEach((to, from, next) => {
  // setAccessToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjBhMzQ2NGU1ZDUxODAxZWM4ODUyYTQ5Mjc5OWQ3YjgyNmI1ZjVjZWQwOGZkY2I4ZGIzNWIwYjFjY2I1YWE4ZmJhMGQzM2FlY2NmYjY1ZGRiIn0.eyJhdWQiOiIyIiwianRpIjoiMGEzNDY0ZTVkNTE4MDFlYzg4NTJhNDkyNzk5ZDdiODI2YjVmNWNlZDA4ZmRjYjhkYjM1YjBiMWNjYjVhYThmYmEwZDMzYWVjY2ZiNjVkZGIiLCJpYXQiOjE2MTAwNzcwMTgsIm5iZiI6MTYxMDA3NzAxOCwiZXhwIjoxNjEwNjgxODE4LCJzdWIiOiI1Iiwic2NvcGVzIjpbIioiXX0.euPA0i7hwMsEynpjM1-rommUDObJ_gSfUGSb4YtRKd93PNZ4q9uNm9NXvAtzLgm3TwkbGrRYI63jzyD1hozE9S2lYIc9QNbk03uQbvXu3IaBGYAEmhLJGwgX24rGJIYllZhGdeV0DLSAyheAHQREt1Wqn04zKOfd12uW-MjVcVfBhj_bJ2W3YOEiMUTzZoiHpnY4HGB3fEJmwkxB6ujyxUi8ztEG1sX6HirfHVtd-9uByGvm8RNTKF-8NB5tbi_2KRGo3h8qVkB4Ngu7EtNNj4DhgU4WHeff-SS9k6xFsZUT_mUWC5p_8SQhVEOtVhQx_kWY0-d63bK1W9ml-T0H38uv7b1gNstWiUCcOx47xBwRQPMNsHRweqjPCVP7ST5ylSLlzhLZv4-IwSdxYvOMPnqDVa9XGWKXuK_sfMQRF3Z1f7D_4xtxdPE8cR3-6PyR1zGytJja_glIsOf9kqpvEq2L0I8BFQfMUnKc9glGREsL1CUpA3maD89UU6qmhCLH9V1frXXt_Q51HKeB5MR3qMxGYAlw5TeQnRVR-eisfyGtrqM9PZDaV358bVkW9ALjnMwSwMZiwrYLRNs7qpIUYcWklCMmuOXoLKTIrOa-66On-d0ULPpFLvDcNK9RPpYp9tsees1nH6jk0V0eLkwe29uX2apnF5JZxt-NSQchLV0')
  if (allAllow || whiteList.indexOf(returnCitySN["cip"]) > -1) {
    if (
      /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
      /(Android)/i.test(navigator.userAgent)
    ) {
      if (
        to.name == "Home" ||
        to.name == "ServiceDisclosure" ||
        to.name == "serviceDetail" ||
        to.name == "dataDisclosure" ||
        to.name == "Online" ||
        to.name == "Article" ||
        to.name == "AnnouncementList" ||
        to.name == "Dean" ||
        to.name == "SearchDetail" ||
        to.name == "Qusetion" ||
        getAccessToken()
      ) {
        if (to.query.wxcode) {
          store.dispatch("login", to.query.wxcode).then(res => {
            Toast("登录成功");
            setAccessToken(res.access_token);
            if (store.getters.nowPath == "/SelectEvaluateType") {
              next();
            } else {
              next({ path: store.getters.nowPath, replace: true });
            }
          });
        } else if (to.query.code) {
          store
            .dispatch("jaccountLogin", {
              code: to.query.code,
              url: redirectUrl
            })
            .then(res => {
              Toast("登录成功");
              setAccessToken(res.access_token);
              console.log("上:" + store.getters.nowPath);
              if (store.getters.nowPath == "/SelectEvaluateType") {
                next();
              } else {
                next({ path: store.getters.nowPath, replace: true });
              }
            });
        } else {
          store.dispatch("commitNowPath", to.fullPath).then(() => {
            next();
          });
        }
      } else {
        if (to.query.wxcode) {
          store.dispatch("login", to.query.wxcode).then(res => {
            Toast("登录成功");
            setAccessToken(res.access_token);
            next({ path: store.getters.nowPath, replace: true });
          });
        } else if (to.query.code) {
          store
            .dispatch("jaccountLogin", {
              code: to.query.code,
              url: redirectUrl
            })
            .then(res => {
              Toast("登录成功");
              console.log("下:" + store.getters.nowPath);
              setAccessToken(res.access_token);
              next({ path: store.getters.nowPath, replace: true });
            });
        } else {
          if (
            navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
          ) {
            store.dispatch("commitNowPath", to.fullPath).then(() => {
              window.location.href =
                "https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=essential&client_id=N7WGL0JVqs3IiSJGdP4A&redirect_uri=" +
                redirectUrl;
            });
          } else {
            store.dispatch("commitNowPath", to.fullPath).then(() => {
              window.location.href =
                "https://jaccount.sjtu.edu.cn/oauth2/authorize?response_type=code&scope=essential&client_id=N7WGL0JVqs3IiSJGdP4A&redirect_uri=" +
                redirectUrl;
            });
          }
        }
      }
    } else {
      if (window.location.pathname == "/Article") {
        window.location.href =
          window.$pcHtml + "/BulletinArticle" + window.location.search;
      } else {
        window.location.href =
          window.$pcHtml + window.location.pathname + window.location.search;
      }
    }
  } else {
    if (to.name == "Building") next();
    else next({ path: "/Building", replace: true });
  }
});

router.afterEach(() => {});

// WEBPACK FOOTER //
// ./src/permission.js



// WEBPACK FOOTER //
// ./src/permission.js